/*
* 	Constants
*	These variables never change
*/
var BREAKPOINT_XS = 576,
	BREAKPOINT_SM = 768,
	BREAKPOINT_MD = 992,
	BREAKPOINT_LG = 1200;

/*
* 	Application
*	- Main controller for the objects of this site.
*/
var Application = function()
{

	var self = this;

	self.started = false;

	self.ready = function()
	{
		// application.modal = new Modal();
		self.anchorScroll	= new AnchorScroll();
		self.responsiveCopy = new ResponsiveCopy();
		self.stickyScroll	= new StickyScroll();
		self.targetDate		= new TargetDate();
		self.dispatchEvent( Event.ApplicationReady );
	};

	self.loaded = function()
	{
		setWidth( $(window).width() );
		self.started = true;
		self.dispatchEvent( Event.ApplicationLoaded );
	};

	self.resize = function( new_width )
	{ 
		setWidth( new_width );
	};

	function setWidth( width )
	{
		self.width = width + ( window.innerWidth - document.documentElement.clientWidth );
		self.dispatchEvent( Event.ApplicationResize, self.width );
	}

};
Application.prototype = Object.create( EventHandler.prototype );

var application = new Application();
var debug = new Debug( true );

//Application Entrypoint
( function( window, $ )
{
	//OnStart
	$( window ).on( 'load', function(){
		application.loaded();
	} );

	$( document ).ready( function(){
		application.ready();
	} );

	//OnResize
	$( window ).resize( function(){
		if( application !== null )
			application.resize( $( window ).width() );
	} );
})(window, jQuery);